module.exports = __webpack_public_path__ + "media/images/new_landing/hp/tile-2-ff788262e9c3ed5aec5d1a6b3735824a.jpg";